import classNames from 'classnames';
import React from 'react'
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'
import {
    iconMargin,
    hLtPattern1,
    hRtPattern1,
    globalGreen,
    hGlobIcon,
} from './Page_Acfbuilder_Wrapper_Content20.module.css'

export default function Page_Acfbuilder_Wrapper_Content20({ data }) {
    const { content20Title, content20RightText, content20Icon, content20ButtonText, content20LeftText, content20ButtonLink, content20AdditionalTopMargin, content20BackgroundColor, content20ButtonExternalLink } = data
    return (
        <div className={`container home-global-cont ${content20Icon ? '' : 'careers-commit-wrap'} ${content20AdditionalTopMargin ? iconMargin : ''}`} >
            <div className='global-wrap'>
                <div className={classNames('global-green', globalGreen)}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className={classNames('h-glob-icon', hGlobIcon)}>
                                    <GatsbyImage image={getImage(content20Icon?.localFile)}
                                        alt='icon'
                                    />
                                </div>
                                <h2 className='heading-level-2 text-center'>
                                    {content20Title && parser(content20Title)}
                                </h2>
                            </div>
                            <div className='col-md-6'>
                                {content20LeftText && <p>{content20LeftText}</p>}
                            </div>
                            <div className='col-md-6'>
                                {content20RightText && <p>{parser(content20RightText)}</p>}
                            </div>
                            <div className='col-md-12 text-center h-globe-btn-sec mt-4'>
                                {content20ButtonExternalLink ? (
                                    <a href={content20ButtonExternalLink} className="btn blue-btn">
                                        {content20ButtonText}
                                    </a>
                                ) : content20ButtonLink ? (
                                    <Link to={content20ButtonLink.uri} className='btn blue-btn'>
                                        {content20ButtonText}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className={hLtPattern1}>
                        <StaticImage
                            src='../../../images/home-lt-pattern.png'
                            alt='image'
                        />
                    </div>
                    <div className={hRtPattern1}>
                        <StaticImage
                            src='../../../images/home-rt-pattern.png'
                            alt='image'
                        />
                    </div>
                    <div className='h-btm-pattern-1'>
                        <StaticImage
                            src='../../../images/mobile-green-pattern.png'
                            alt='image'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
